import { Tabs } from "antd";
import React, { useEffect } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { Routes } from "../../common/Routes";
import "./index.css";
import User from "./user/User";
import { UserList } from "./userList";
import { allUsersTab } from "./userList/model";
import { AppSideBarPageActions, SideBarOptions } from "../../parts/AppSideBar/model";
import { useDispatch } from "react-redux";

export const UserPage = () => {
  const match = useRouteMatch();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AppSideBarPageActions.updateSelectedSideBar(SideBarOptions.USERS));
  });

  return (
    <div>
      <div className={"userContainer"}>
        <Switch>
          <Route
            exact={true}
            path={`${match.path}${Routes.Users.user.path}`}
            component={User}
          />
          <Route
            exact={true}
            path={match.path}
          >
            <div className={"userTitle"}>Users</div>
            <Tabs
              className={"tabContainer"}
              type="editable-card"
              hideAdd
            >
              <Tabs.TabPane
                tab={allUsersTab.name}
                key={allUsersTab.id}
                closable={false}
              >
                <UserList/>
              </Tabs.TabPane>
            </Tabs>
          </Route>
          <Route>
            <Redirect to={Routes.NotFound.path}/>
          </Route>
        </Switch>
      </div>
    </div>
  );
};
